import { markBumblebeeSessionRead } from "../../../../../../../../../shared/api/bumblebee/bumblebee";

export async function markBumblebeeChatReadService(
	sessionId: string,
): Promise<boolean> {
	const result = await markBumblebeeSessionRead(sessionId);
	return Boolean(result.data?.success);
}
